import React from "react";
import themePropTypes from "../theme-prop-types";

const FieldWrapper = ({ children }) => <div>{children}</div>;

FieldWrapper.propTypes = themePropTypes.fieldWrapper;

export default FieldWrapper;
